var tn = Object.defineProperty;
var re = (t) => {
  throw TypeError(t);
};
var en = (t, e, n) => e in t ? tn(t, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[e] = n;
var z = (t, e, n) => en(t, typeof e != "symbol" ? e + "" : e, n), Nt = (t, e, n) => e.has(t) || re("Cannot " + n);
var rt = (t, e, n) => (Nt(t, e, "read from private field"), n ? n.call(t) : e.get(t)), wt = (t, e, n) => e.has(t) ? re("Cannot add the same private member more than once") : e instanceof WeakSet ? e.add(t) : e.set(t, n), yt = (t, e, n, r) => (Nt(t, e, "write to private field"), r ? r.call(t, n) : e.set(t, n), n), dt = (t, e, n) => (Nt(t, e, "access private method"), n);
import nn from "quantize";
import et from "tinycolor2";
import { useState as rn, useSyncExternalStore as on } from "react";
const oe = (t, e) => {
  const n = document.createElement("canvas");
  return n.width = t, n.height = e, n;
};
class $t {
  constructor({ image: e, width: n, height: r }) {
    z(this, "width");
    z(this, "height");
    z(this, "element");
    z(this, "context");
    // Does this need to be optional?
    z(this, "image");
    z(this, "imageData");
    var o;
    e ? (this.image = e, e instanceof HTMLImageElement ? (this.width = n || e.naturalWidth || e.offsetWidth, this.height = r || e.naturalHeight || e.offsetHeight || e.height) : e instanceof ImageBitmap ? (this.width = n || e.width, this.height = r || e.height) : (this.width = n || 0, this.height = r || 0), this.element = oe(this.width, this.height), this.context = this.element.getContext("2d"), (o = this.context) == null || o.drawImage(e, 0, 0)) : (this.width = n || 0, this.height = r || 0, this.element = oe(this.width, this.height), this.context = this.element.getContext("2d"));
  }
  /** Generate data from the provided image */
  getImageData() {
    if (this.context)
      return this.imageData = this.context.getImageData(0, 0, this.width, this.height), this.imageData;
  }
  //** This is much more of an image processing action then a canvas action. */
  getImageBorderData(e) {
    if (!this.context)
      return;
    const n = this.context.getImageData(0, 0, this.width, e), r = this.context.getImageData(0, this.height, this.width, -Math.abs(e)), o = this.context.getImageData(this.width, 0, -Math.abs(e), this.height), s = this.context.getImageData(0, 0, 10, this.height);
    return [...n.data, ...r.data, ...o.data, ...s.data];
  }
  /** Remove the canvas from the DOM */
  removeCanvas() {
    this.element.remove(), this.context = null, this.image = void 0, this.imageData = void 0, this.width = 0, this.height = 0;
  }
}
class E0 extends $t {
  constructor({
    image: e,
    backgroundColor: n,
    width: r,
    height: o
  }) {
    super({ image: e, width: r, height: o }), n && this.setBackgroundColor(n);
  }
  setBackgroundColor(e) {
    if (!this.context) throw new Error("No context found");
    this.context.fillStyle = e, this.context.fillRect(0, 0, this.width, this.height), this.context.drawImage(this.element, 0, 0);
  }
  setSize(e, n) {
    this.width = e, this.height = n, this.element.width = e, this.element.height = n;
  }
}
class A0 extends $t {
  // constructor(image, canvaswidth, canvasHeight) {
  //   super(image, canvaswidth, canvasHeight);
  //   this.image = image;
  //   this.canvas = createCanvas(canvaswidth, canvasHeight);
  //   this.context = this.canvas.getContext("2d");
  //   this.width = image.naturalWidth || image.offsetWidth || image.width;
  //   this.height = image.naturalHeight || image.offsetHeight || image.height;
  //   this.isSquare = this.width == this.height;
  //   this.scaleFactor = 1;
  //   this.options = {
  //     x: 0,
  //     y: 0,
  //     dw: 0,
  //     dh: 0,
  //   };
  //   this.sizeScaling = this.calculateSizeScaling();
  //   this.context.imageSmoothingQuality = "high";
  // }
  // set fillColor(hexColor) {
  //   this.drawRectangle(hexColor);
  //   this.reDrawImage();
  // }
  // reDrawImage() {
  //   return this.context.drawImage(
  //     this.image,
  //     Math.floor(this.options.x),
  //     Math.floor(this.options.y),
  //     this.options.dw,
  //     this.options.dh
  //   );
  // }
  // calculateSizeScaling() {
  //   const longestSide = this.width > this.height ? "x" : "y";
  //   let sizeOffset = 0;
  //   let dw = 0;
  //   let dh = 0;
  //   if (longestSide == "x") {
  //     dw = 136;
  //     sizeOffset = dw / this.width;
  //   } else {
  //     dh = 136;
  //     sizeOffset = dh / this.height;
  //   }
  //   // Set Width
  //   this.options.dh = this.height * sizeOffset;
  //   // Set Height
  //   this.options.dw = this.width * sizeOffset;
  //   // Set position Options
  //   this.options.x = (this.canvas.width - this.options.dw) / 2;
  //   this.options.y = (this.canvas.height - this.options.dh) / 2;
  //   this.scaleFactor = sizeOffset;
  //   return sizeOffset;
  // }
  // drawRectangle(fillColor) {
  //   this.context.fillStyle = fillColor;
  //   this.roundRect(
  //     this.context,
  //     0,
  //     0,
  //     this.canvas.width,
  //     this.canvas.height,
  //     8,
  //     1,
  //     false
  //   );
  // }
  // roundRect(ctx, x, y, width, height, radius, fill, stroke) {
  //   if (typeof stroke === "undefined") {
  //     stroke = true;
  //   }
  //   if (typeof radius === "undefined") {
  //     radius = 5;
  //   }
  //   if (typeof radius === "number") {
  //     radius = { tl: radius, tr: radius, br: radius, bl: radius };
  //   } else {
  //     let defaultRadius = { tl: 0, tr: 0, br: 0, bl: 0 };
  //     for (var side in defaultRadius) {
  //       radius[side] = radius[side] || defaultRadius[side];
  //     }
  //   }
  //   ctx.beginPath();
  //   ctx.moveTo(x + radius.tl, y);
  //   ctx.lineTo(x + width - radius.tr, y);
  //   ctx.quadraticCurveTo(x + width, y, x + width, y + radius.tr);
  //   ctx.lineTo(x + width, y + height - radius.br);
  //   ctx.quadraticCurveTo(
  //     x + width,
  //     y + height,
  //     x + width - radius.br,
  //     y + height
  //   );
  //   ctx.lineTo(x + radius.bl, y + height);
  //   ctx.quadraticCurveTo(x, y + height, x, y + height - radius.bl);
  //   ctx.lineTo(x, y + radius.tl);
  //   ctx.quadraticCurveTo(x, y, x + radius.tl, y);
  //   ctx.closePath();
  //   if (fill) {
  //     ctx.fill();
  //   }
  //   if (stroke) {
  //     ctx.stroke();
  //   }
  // }
}
const { min: sn, max: cn } = Math, nt = (t, e = 0, n = 1) => sn(cn(e, t), n), Wt = (t) => {
  t._clipped = !1, t._unclipped = t.slice(0);
  for (let e = 0; e <= 3; e++)
    e < 3 ? ((t[e] < 0 || t[e] > 255) && (t._clipped = !0), t[e] = nt(t[e], 0, 255)) : e === 3 && (t[e] = nt(t[e], 0, 1));
  return t;
}, ye = {};
for (let t of [
  "Boolean",
  "Number",
  "String",
  "Function",
  "Array",
  "Date",
  "RegExp",
  "Undefined",
  "Null"
])
  ye[`[object ${t}]`] = t.toLowerCase();
function C(t) {
  return ye[Object.prototype.toString.call(t)] || "object";
}
const x = (t, e = null) => t.length >= 3 ? Array.prototype.slice.call(t) : C(t[0]) == "object" && e ? e.split("").filter((n) => t[0][n] !== void 0).map((n) => t[0][n]) : t[0].slice(0), it = (t) => {
  if (t.length < 2) return null;
  const e = t.length - 1;
  return C(t[e]) == "string" ? t[e].toLowerCase() : null;
}, { PI: Lt, min: ke, max: _e } = Math, Y = (t) => Math.round(t * 100) / 100, Xt = (t) => Math.round(t * 100) / 100, Z = Lt * 2, St = Lt / 3, an = Lt / 180, fn = 180 / Lt;
function xe(t) {
  return [...t.slice(0, 3).reverse(), ...t.slice(3)];
}
const _ = {
  format: {},
  autodetect: []
};
class l {
  constructor(...e) {
    const n = this;
    if (C(e[0]) === "object" && e[0].constructor && e[0].constructor === this.constructor)
      return e[0];
    let r = it(e), o = !1;
    if (!r) {
      o = !0, _.sorted || (_.autodetect = _.autodetect.sort((s, c) => c.p - s.p), _.sorted = !0);
      for (let s of _.autodetect)
        if (r = s.test(...e), r) break;
    }
    if (_.format[r]) {
      const s = _.format[r].apply(
        null,
        o ? e : e.slice(0, -1)
      );
      n._rgb = Wt(s);
    } else
      throw new Error("unknown format: " + e);
    n._rgb.length === 3 && n._rgb.push(1);
  }
  toString() {
    return C(this.hex) == "function" ? this.hex() : `[${this._rgb.join(",")}]`;
  }
}
const ln = "3.1.2", $ = (...t) => new l(...t);
$.version = ln;
const at = {
  aliceblue: "#f0f8ff",
  antiquewhite: "#faebd7",
  aqua: "#00ffff",
  aquamarine: "#7fffd4",
  azure: "#f0ffff",
  beige: "#f5f5dc",
  bisque: "#ffe4c4",
  black: "#000000",
  blanchedalmond: "#ffebcd",
  blue: "#0000ff",
  blueviolet: "#8a2be2",
  brown: "#a52a2a",
  burlywood: "#deb887",
  cadetblue: "#5f9ea0",
  chartreuse: "#7fff00",
  chocolate: "#d2691e",
  coral: "#ff7f50",
  cornflowerblue: "#6495ed",
  cornsilk: "#fff8dc",
  crimson: "#dc143c",
  cyan: "#00ffff",
  darkblue: "#00008b",
  darkcyan: "#008b8b",
  darkgoldenrod: "#b8860b",
  darkgray: "#a9a9a9",
  darkgreen: "#006400",
  darkgrey: "#a9a9a9",
  darkkhaki: "#bdb76b",
  darkmagenta: "#8b008b",
  darkolivegreen: "#556b2f",
  darkorange: "#ff8c00",
  darkorchid: "#9932cc",
  darkred: "#8b0000",
  darksalmon: "#e9967a",
  darkseagreen: "#8fbc8f",
  darkslateblue: "#483d8b",
  darkslategray: "#2f4f4f",
  darkslategrey: "#2f4f4f",
  darkturquoise: "#00ced1",
  darkviolet: "#9400d3",
  deeppink: "#ff1493",
  deepskyblue: "#00bfff",
  dimgray: "#696969",
  dimgrey: "#696969",
  dodgerblue: "#1e90ff",
  firebrick: "#b22222",
  floralwhite: "#fffaf0",
  forestgreen: "#228b22",
  fuchsia: "#ff00ff",
  gainsboro: "#dcdcdc",
  ghostwhite: "#f8f8ff",
  gold: "#ffd700",
  goldenrod: "#daa520",
  gray: "#808080",
  green: "#008000",
  greenyellow: "#adff2f",
  grey: "#808080",
  honeydew: "#f0fff0",
  hotpink: "#ff69b4",
  indianred: "#cd5c5c",
  indigo: "#4b0082",
  ivory: "#fffff0",
  khaki: "#f0e68c",
  laserlemon: "#ffff54",
  lavender: "#e6e6fa",
  lavenderblush: "#fff0f5",
  lawngreen: "#7cfc00",
  lemonchiffon: "#fffacd",
  lightblue: "#add8e6",
  lightcoral: "#f08080",
  lightcyan: "#e0ffff",
  lightgoldenrod: "#fafad2",
  lightgoldenrodyellow: "#fafad2",
  lightgray: "#d3d3d3",
  lightgreen: "#90ee90",
  lightgrey: "#d3d3d3",
  lightpink: "#ffb6c1",
  lightsalmon: "#ffa07a",
  lightseagreen: "#20b2aa",
  lightskyblue: "#87cefa",
  lightslategray: "#778899",
  lightslategrey: "#778899",
  lightsteelblue: "#b0c4de",
  lightyellow: "#ffffe0",
  lime: "#00ff00",
  limegreen: "#32cd32",
  linen: "#faf0e6",
  magenta: "#ff00ff",
  maroon: "#800000",
  maroon2: "#7f0000",
  maroon3: "#b03060",
  mediumaquamarine: "#66cdaa",
  mediumblue: "#0000cd",
  mediumorchid: "#ba55d3",
  mediumpurple: "#9370db",
  mediumseagreen: "#3cb371",
  mediumslateblue: "#7b68ee",
  mediumspringgreen: "#00fa9a",
  mediumturquoise: "#48d1cc",
  mediumvioletred: "#c71585",
  midnightblue: "#191970",
  mintcream: "#f5fffa",
  mistyrose: "#ffe4e1",
  moccasin: "#ffe4b5",
  navajowhite: "#ffdead",
  navy: "#000080",
  oldlace: "#fdf5e6",
  olive: "#808000",
  olivedrab: "#6b8e23",
  orange: "#ffa500",
  orangered: "#ff4500",
  orchid: "#da70d6",
  palegoldenrod: "#eee8aa",
  palegreen: "#98fb98",
  paleturquoise: "#afeeee",
  palevioletred: "#db7093",
  papayawhip: "#ffefd5",
  peachpuff: "#ffdab9",
  peru: "#cd853f",
  pink: "#ffc0cb",
  plum: "#dda0dd",
  powderblue: "#b0e0e6",
  purple: "#800080",
  purple2: "#7f007f",
  purple3: "#a020f0",
  rebeccapurple: "#663399",
  red: "#ff0000",
  rosybrown: "#bc8f8f",
  royalblue: "#4169e1",
  saddlebrown: "#8b4513",
  salmon: "#fa8072",
  sandybrown: "#f4a460",
  seagreen: "#2e8b57",
  seashell: "#fff5ee",
  sienna: "#a0522d",
  silver: "#c0c0c0",
  skyblue: "#87ceeb",
  slateblue: "#6a5acd",
  slategray: "#708090",
  slategrey: "#708090",
  snow: "#fffafa",
  springgreen: "#00ff7f",
  steelblue: "#4682b4",
  tan: "#d2b48c",
  teal: "#008080",
  thistle: "#d8bfd8",
  tomato: "#ff6347",
  turquoise: "#40e0d0",
  violet: "#ee82ee",
  wheat: "#f5deb3",
  white: "#ffffff",
  whitesmoke: "#f5f5f5",
  yellow: "#ffff00",
  yellowgreen: "#9acd32"
}, un = /^#?([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/, hn = /^#?([A-Fa-f0-9]{8}|[A-Fa-f0-9]{4})$/, Me = (t) => {
  if (t.match(un)) {
    (t.length === 4 || t.length === 7) && (t = t.substr(1)), t.length === 3 && (t = t.split(""), t = t[0] + t[0] + t[1] + t[1] + t[2] + t[2]);
    const e = parseInt(t, 16), n = e >> 16, r = e >> 8 & 255, o = e & 255;
    return [n, r, o, 1];
  }
  if (t.match(hn)) {
    (t.length === 5 || t.length === 9) && (t = t.substr(1)), t.length === 4 && (t = t.split(""), t = t[0] + t[0] + t[1] + t[1] + t[2] + t[2] + t[3] + t[3]);
    const e = parseInt(t, 16), n = e >> 24 & 255, r = e >> 16 & 255, o = e >> 8 & 255, s = Math.round((e & 255) / 255 * 100) / 100;
    return [n, r, o, s];
  }
  throw new Error(`unknown hex color: ${t}`);
}, { round: kt } = Math, $e = (...t) => {
  let [e, n, r, o] = x(t, "rgba"), s = it(t) || "auto";
  o === void 0 && (o = 1), s === "auto" && (s = o < 1 ? "rgba" : "rgb"), e = kt(e), n = kt(n), r = kt(r);
  let a = "000000" + (e << 16 | n << 8 | r).toString(16);
  a = a.substr(a.length - 6);
  let f = "0" + kt(o * 255).toString(16);
  switch (f = f.substr(f.length - 2), s.toLowerCase()) {
    case "rgba":
      return `#${a}${f}`;
    case "argb":
      return `#${f}${a}`;
    default:
      return `#${a}`;
  }
};
l.prototype.name = function() {
  const t = $e(this._rgb, "rgb");
  for (let e of Object.keys(at))
    if (at[e] === t) return e.toLowerCase();
  return t;
};
_.format.named = (t) => {
  if (t = t.toLowerCase(), at[t]) return Me(at[t]);
  throw new Error("unknown color name: " + t);
};
_.autodetect.push({
  p: 5,
  test: (t, ...e) => {
    if (!e.length && C(t) === "string" && at[t.toLowerCase()])
      return "named";
  }
});
l.prototype.alpha = function(t, e = !1) {
  return t !== void 0 && C(t) === "number" ? e ? (this._rgb[3] = t, this) : new l([this._rgb[0], this._rgb[1], this._rgb[2], t], "rgb") : this._rgb[3];
};
l.prototype.clipped = function() {
  return this._rgb._clipped || !1;
};
const q = {
  // Corresponds roughly to RGB brighter/darker
  Kn: 18,
  // D65 standard referent
  labWhitePoint: "d65",
  Xn: 0.95047,
  Yn: 1,
  Zn: 1.08883,
  kE: 216 / 24389,
  kKE: 8,
  kK: 24389 / 27,
  RefWhiteRGB: {
    // sRGB
    X: 0.95047,
    Y: 1,
    Z: 1.08883
  },
  MtxRGB2XYZ: {
    m00: 0.4124564390896922,
    m01: 0.21267285140562253,
    m02: 0.0193338955823293,
    m10: 0.357576077643909,
    m11: 0.715152155287818,
    m12: 0.11919202588130297,
    m20: 0.18043748326639894,
    m21: 0.07217499330655958,
    m22: 0.9503040785363679
  },
  MtxXYZ2RGB: {
    m00: 3.2404541621141045,
    m01: -0.9692660305051868,
    m02: 0.055643430959114726,
    m10: -1.5371385127977166,
    m11: 1.8760108454466942,
    m12: -0.2040259135167538,
    m20: -0.498531409556016,
    m21: 0.041556017530349834,
    m22: 1.0572251882231791
  },
  // used in rgb2xyz
  As: 0.9414285350000001,
  Bs: 1.040417467,
  Cs: 1.089532651,
  MtxAdaptMa: {
    m00: 0.8951,
    m01: -0.7502,
    m02: 0.0389,
    m10: 0.2664,
    m11: 1.7135,
    m12: -0.0685,
    m20: -0.1614,
    m21: 0.0367,
    m22: 1.0296
  },
  MtxAdaptMaI: {
    m00: 0.9869929054667123,
    m01: 0.43230526972339456,
    m02: -0.008528664575177328,
    m10: -0.14705425642099013,
    m11: 0.5183602715367776,
    m12: 0.04004282165408487,
    m20: 0.15996265166373125,
    m21: 0.0492912282128556,
    m22: 0.9684866957875502
  }
}, bn = /* @__PURE__ */ new Map([
  // ASTM E308-01
  ["a", [1.0985, 0.35585]],
  // Wyszecki & Stiles, p. 769
  ["b", [1.0985, 0.35585]],
  // C ASTM E308-01
  ["c", [0.98074, 1.18232]],
  // D50 (ASTM E308-01)
  ["d50", [0.96422, 0.82521]],
  // D55 (ASTM E308-01)
  ["d55", [0.95682, 0.92149]],
  // D65 (ASTM E308-01)
  ["d65", [0.95047, 1.08883]],
  // E (ASTM E308-01)
  ["e", [1, 1, 1]],
  // F2 (ASTM E308-01)
  ["f2", [0.99186, 0.67393]],
  // F7 (ASTM E308-01)
  ["f7", [0.95041, 1.08747]],
  // F11 (ASTM E308-01)
  ["f11", [1.00962, 0.6435]],
  ["icc", [0.96422, 0.82521]]
]);
function W(t) {
  const e = bn.get(String(t).toLowerCase());
  if (!e)
    throw new Error("unknown Lab illuminant " + t);
  q.labWhitePoint = t, q.Xn = e[0], q.Zn = e[1];
}
function gt() {
  return q.labWhitePoint;
}
const Kt = (...t) => {
  t = x(t, "lab");
  const [e, n, r] = t, [o, s, c] = dn(e, n, r), [a, f, i] = Ce(o, s, c);
  return [a, f, i, t.length > 3 ? t[3] : 1];
}, dn = (t, e, n) => {
  const { kE: r, kK: o, kKE: s, Xn: c, Yn: a, Zn: f } = q, i = (t + 16) / 116, h = 2e-3 * e + i, d = i - 5e-3 * n, b = h * h * h, g = d * d * d, k = b > r ? b : (116 * h - 16) / o, R = t > s ? Math.pow((t + 16) / 116, 3) : t / o, p = g > r ? g : (116 * d - 16) / o, w = k * c, j = R * a, I = p * f;
  return [w, j, I];
}, Pt = (t) => {
  const e = Math.sign(t);
  return t = Math.abs(t), (t <= 31308e-7 ? t * 12.92 : 1.055 * Math.pow(t, 1 / 2.4) - 0.055) * e;
}, Ce = (t, e, n) => {
  const { MtxAdaptMa: r, MtxAdaptMaI: o, MtxXYZ2RGB: s, RefWhiteRGB: c, Xn: a, Yn: f, Zn: i } = q, h = a * r.m00 + f * r.m10 + i * r.m20, d = a * r.m01 + f * r.m11 + i * r.m21, b = a * r.m02 + f * r.m12 + i * r.m22, g = c.X * r.m00 + c.Y * r.m10 + c.Z * r.m20, k = c.X * r.m01 + c.Y * r.m11 + c.Z * r.m21, R = c.X * r.m02 + c.Y * r.m12 + c.Z * r.m22, p = (t * r.m00 + e * r.m10 + n * r.m20) * (g / h), w = (t * r.m01 + e * r.m11 + n * r.m21) * (k / d), j = (t * r.m02 + e * r.m12 + n * r.m22) * (R / b), I = p * o.m00 + w * o.m10 + j * o.m20, N = p * o.m01 + w * o.m11 + j * o.m21, O = p * o.m02 + w * o.m12 + j * o.m22, E = Pt(
    I * s.m00 + N * s.m10 + O * s.m20
  ), u = Pt(
    I * s.m01 + N * s.m11 + O * s.m21
  ), m = Pt(
    I * s.m02 + N * s.m12 + O * s.m22
  );
  return [E * 255, u * 255, m * 255];
}, Ft = (...t) => {
  const [e, n, r, ...o] = x(t, "rgb"), [s, c, a] = Ee(e, n, r), [f, i, h] = gn(s, c, a);
  return [f, i, h, ...o.length > 0 && o[0] < 1 ? [o[0]] : []];
};
function gn(t, e, n) {
  const { Xn: r, Yn: o, Zn: s, kE: c, kK: a } = q, f = t / r, i = e / o, h = n / s, d = f > c ? Math.pow(f, 1 / 3) : (a * f + 16) / 116, b = i > c ? Math.pow(i, 1 / 3) : (a * i + 16) / 116, g = h > c ? Math.pow(h, 1 / 3) : (a * h + 16) / 116;
  return [116 * b - 16, 500 * (d - b), 200 * (b - g)];
}
function jt(t) {
  const e = Math.sign(t);
  return t = Math.abs(t), (t <= 0.04045 ? t / 12.92 : Math.pow((t + 0.055) / 1.055, 2.4)) * e;
}
const Ee = (t, e, n) => {
  t = jt(t / 255), e = jt(e / 255), n = jt(n / 255);
  const { MtxRGB2XYZ: r, MtxAdaptMa: o, MtxAdaptMaI: s, Xn: c, Yn: a, Zn: f, As: i, Bs: h, Cs: d } = q;
  let b = t * r.m00 + e * r.m10 + n * r.m20, g = t * r.m01 + e * r.m11 + n * r.m21, k = t * r.m02 + e * r.m12 + n * r.m22;
  const R = c * o.m00 + a * o.m10 + f * o.m20, p = c * o.m01 + a * o.m11 + f * o.m21, w = c * o.m02 + a * o.m12 + f * o.m22;
  let j = b * o.m00 + g * o.m10 + k * o.m20, I = b * o.m01 + g * o.m11 + k * o.m21, N = b * o.m02 + g * o.m12 + k * o.m22;
  return j *= R / i, I *= p / h, N *= w / d, b = j * s.m00 + I * s.m10 + N * s.m20, g = j * s.m01 + I * s.m11 + N * s.m21, k = j * s.m02 + I * s.m12 + N * s.m22, [b, g, k];
};
l.prototype.lab = function() {
  return Ft(this._rgb);
};
const mn = (...t) => new l(...t, "lab");
Object.assign($, { lab: mn, getLabWhitePoint: gt, setLabWhitePoint: W });
_.format.lab = Kt;
_.autodetect.push({
  p: 2,
  test: (...t) => {
    if (t = x(t, "lab"), C(t) === "array" && t.length === 3)
      return "lab";
  }
});
l.prototype.darken = function(t = 1) {
  const e = this, n = e.lab();
  return n[0] -= q.Kn * t, new l(n, "lab").alpha(e.alpha(), !0);
};
l.prototype.brighten = function(t = 1) {
  return this.darken(-t);
};
l.prototype.darker = l.prototype.darken;
l.prototype.brighter = l.prototype.brighten;
l.prototype.get = function(t) {
  const [e, n] = t.split("."), r = this[e]();
  if (n) {
    const o = e.indexOf(n) - (e.substr(0, 2) === "ok" ? 2 : 0);
    if (o > -1) return r[o];
    throw new Error(`unknown channel ${n} in mode ${e}`);
  } else
    return r;
};
const { pow: pn } = Math, wn = 1e-7, yn = 20;
l.prototype.luminance = function(t, e = "rgb") {
  if (t !== void 0 && C(t) === "number") {
    if (t === 0)
      return new l([0, 0, 0, this._rgb[3]], "rgb");
    if (t === 1)
      return new l([255, 255, 255, this._rgb[3]], "rgb");
    let n = this.luminance(), r = yn;
    const o = (c, a) => {
      const f = c.interpolate(a, 0.5, e), i = f.luminance();
      return Math.abs(t - i) < wn || !r-- ? f : i > t ? o(c, f) : o(f, a);
    }, s = (n > t ? o(new l([0, 0, 0]), this) : o(this, new l([255, 255, 255]))).rgb();
    return new l([...s, this._rgb[3]]);
  }
  return kn(...this._rgb.slice(0, 3));
};
const kn = (t, e, n) => (t = It(t), e = It(e), n = It(n), 0.2126 * t + 0.7152 * e + 0.0722 * n), It = (t) => (t /= 255, t <= 0.03928 ? t / 12.92 : pn((t + 0.055) / 1.055, 2.4)), B = {}, ft = (t, e, n = 0.5, ...r) => {
  let o = r[0] || "lrgb";
  if (!B[o] && !r.length && (o = Object.keys(B)[0]), !B[o])
    throw new Error(`interpolation mode ${o} is not defined`);
  return C(t) !== "object" && (t = new l(t)), C(e) !== "object" && (e = new l(e)), B[o](t, e, n).alpha(
    t.alpha() + n * (e.alpha() - t.alpha())
  );
};
l.prototype.mix = l.prototype.interpolate = function(t, e = 0.5, ...n) {
  return ft(this, t, e, ...n);
};
l.prototype.premultiply = function(t = !1) {
  const e = this._rgb, n = e[3];
  return t ? (this._rgb = [e[0] * n, e[1] * n, e[2] * n, n], this) : new l([e[0] * n, e[1] * n, e[2] * n, n], "rgb");
};
const { sin: _n, cos: xn } = Math, Ae = (...t) => {
  let [e, n, r] = x(t, "lch");
  return isNaN(r) && (r = 0), r = r * an, [e, xn(r) * n, _n(r) * n];
}, Ut = (...t) => {
  t = x(t, "lch");
  const [e, n, r] = t, [o, s, c] = Ae(e, n, r), [a, f, i] = Kt(o, s, c);
  return [a, f, i, t.length > 3 ? t[3] : 1];
}, Mn = (...t) => {
  const e = xe(x(t, "hcl"));
  return Ut(...e);
}, { sqrt: $n, atan2: Cn, round: En } = Math, Le = (...t) => {
  const [e, n, r] = x(t, "lab"), o = $n(n * n + r * r);
  let s = (Cn(r, n) * fn + 360) % 360;
  return En(o * 1e4) === 0 && (s = Number.NaN), [e, o, s];
}, Vt = (...t) => {
  const [e, n, r, ...o] = x(t, "rgb"), [s, c, a] = Ft(e, n, r), [f, i, h] = Le(s, c, a);
  return [f, i, h, ...o.length > 0 && o[0] < 1 ? [o[0]] : []];
};
l.prototype.lch = function() {
  return Vt(this._rgb);
};
l.prototype.hcl = function() {
  return xe(Vt(this._rgb));
};
const An = (...t) => new l(...t, "lch"), Ln = (...t) => new l(...t, "hcl");
Object.assign($, { lch: An, hcl: Ln });
_.format.lch = Ut;
_.format.hcl = Mn;
["lch", "hcl"].forEach(
  (t) => _.autodetect.push({
    p: 2,
    test: (...e) => {
      if (e = x(e, t), C(e) === "array" && e.length === 3)
        return t;
    }
  })
);
l.prototype.saturate = function(t = 1) {
  const e = this, n = e.lch();
  return n[1] += q.Kn * t, n[1] < 0 && (n[1] = 0), new l(n, "lch").alpha(e.alpha(), !0);
};
l.prototype.desaturate = function(t = 1) {
  return this.saturate(-t);
};
l.prototype.set = function(t, e, n = !1) {
  const [r, o] = t.split("."), s = this[r]();
  if (o) {
    const c = r.indexOf(o) - (r.substr(0, 2) === "ok" ? 2 : 0);
    if (c > -1) {
      if (C(e) == "string")
        switch (e.charAt(0)) {
          case "+":
            s[c] += +e;
            break;
          case "-":
            s[c] += +e;
            break;
          case "*":
            s[c] *= +e.substr(1);
            break;
          case "/":
            s[c] /= +e.substr(1);
            break;
          default:
            s[c] = +e;
        }
      else if (C(e) === "number")
        s[c] = e;
      else
        throw new Error("unsupported value for Color.set");
      const a = new l(s, r);
      return n ? (this._rgb = a._rgb, this) : a;
    }
    throw new Error(`unknown channel ${o} in mode ${r}`);
  } else
    return s;
};
l.prototype.tint = function(t = 0.5, ...e) {
  return ft(this, "white", t, ...e);
};
l.prototype.shade = function(t = 0.5, ...e) {
  return ft(this, "black", t, ...e);
};
const Rn = (t, e, n) => {
  const r = t._rgb, o = e._rgb;
  return new l(
    r[0] + n * (o[0] - r[0]),
    r[1] + n * (o[1] - r[1]),
    r[2] + n * (o[2] - r[2]),
    "rgb"
  );
};
B.rgb = Rn;
const { sqrt: Ot, pow: ot } = Math, vn = (t, e, n) => {
  const [r, o, s] = t._rgb, [c, a, f] = e._rgb;
  return new l(
    Ot(ot(r, 2) * (1 - n) + ot(c, 2) * n),
    Ot(ot(o, 2) * (1 - n) + ot(a, 2) * n),
    Ot(ot(s, 2) * (1 - n) + ot(f, 2) * n),
    "rgb"
  );
};
B.lrgb = vn;
const Nn = (t, e, n) => {
  const r = t.lab(), o = e.lab();
  return new l(
    r[0] + n * (o[0] - r[0]),
    r[1] + n * (o[1] - r[1]),
    r[2] + n * (o[2] - r[2]),
    "lab"
  );
};
B.lab = Nn;
const lt = (t, e, n, r) => {
  let o, s;
  r === "hsl" ? (o = t.hsl(), s = e.hsl()) : r === "hsv" ? (o = t.hsv(), s = e.hsv()) : r === "hcg" ? (o = t.hcg(), s = e.hcg()) : r === "hsi" ? (o = t.hsi(), s = e.hsi()) : r === "lch" || r === "hcl" ? (r = "hcl", o = t.hcl(), s = e.hcl()) : r === "oklch" && (o = t.oklch().reverse(), s = e.oklch().reverse());
  let c, a, f, i, h, d;
  (r.substr(0, 1) === "h" || r === "oklch") && ([c, f, h] = o, [a, i, d] = s);
  let b, g, k, R;
  return !isNaN(c) && !isNaN(a) ? (a > c && a - c > 180 ? R = a - (c + 360) : a < c && c - a > 180 ? R = a + 360 - c : R = a - c, g = c + n * R) : isNaN(c) ? isNaN(a) ? g = Number.NaN : (g = a, (h == 1 || h == 0) && r != "hsv" && (b = i)) : (g = c, (d == 1 || d == 0) && r != "hsv" && (b = f)), b === void 0 && (b = f + n * (i - f)), k = h + n * (d - h), r === "oklch" ? new l([k, b, g], r) : new l([g, b, k], r);
}, Re = (t, e, n) => lt(t, e, n, "lch");
B.lch = Re;
B.hcl = Re;
const Sn = (t) => {
  if (C(t) == "number" && t >= 0 && t <= 16777215) {
    const e = t >> 16, n = t >> 8 & 255, r = t & 255;
    return [e, n, r, 1];
  }
  throw new Error("unknown num color: " + t);
}, Pn = (...t) => {
  const [e, n, r] = x(t, "rgb");
  return (e << 16) + (n << 8) + r;
};
l.prototype.num = function() {
  return Pn(this._rgb);
};
const jn = (...t) => new l(...t, "num");
Object.assign($, { num: jn });
_.format.num = Sn;
_.autodetect.push({
  p: 5,
  test: (...t) => {
    if (t.length === 1 && C(t[0]) === "number" && t[0] >= 0 && t[0] <= 16777215)
      return "num";
  }
});
const In = (t, e, n) => {
  const r = t.num(), o = e.num();
  return new l(r + n * (o - r), "num");
};
B.num = In;
const { floor: On } = Math, Bn = (...t) => {
  t = x(t, "hcg");
  let [e, n, r] = t, o, s, c;
  r = r * 255;
  const a = n * 255;
  if (n === 0)
    o = s = c = r;
  else {
    e === 360 && (e = 0), e > 360 && (e -= 360), e < 0 && (e += 360), e /= 60;
    const f = On(e), i = e - f, h = r * (1 - n), d = h + a * (1 - i), b = h + a * i, g = h + a;
    switch (f) {
      case 0:
        [o, s, c] = [g, b, h];
        break;
      case 1:
        [o, s, c] = [d, g, h];
        break;
      case 2:
        [o, s, c] = [h, g, b];
        break;
      case 3:
        [o, s, c] = [h, d, g];
        break;
      case 4:
        [o, s, c] = [b, h, g];
        break;
      case 5:
        [o, s, c] = [g, h, d];
        break;
    }
  }
  return [o, s, c, t.length > 3 ? t[3] : 1];
}, zn = (...t) => {
  const [e, n, r] = x(t, "rgb"), o = ke(e, n, r), s = _e(e, n, r), c = s - o, a = c * 100 / 255, f = o / (255 - c) * 100;
  let i;
  return c === 0 ? i = Number.NaN : (e === s && (i = (n - r) / c), n === s && (i = 2 + (r - e) / c), r === s && (i = 4 + (e - n) / c), i *= 60, i < 0 && (i += 360)), [i, a, f];
};
l.prototype.hcg = function() {
  return zn(this._rgb);
};
const Gn = (...t) => new l(...t, "hcg");
$.hcg = Gn;
_.format.hcg = Bn;
_.autodetect.push({
  p: 1,
  test: (...t) => {
    if (t = x(t, "hcg"), C(t) === "array" && t.length === 3)
      return "hcg";
  }
});
const Yn = (t, e, n) => lt(t, e, n, "hcg");
B.hcg = Yn;
const { cos: st } = Math, Dn = (...t) => {
  t = x(t, "hsi");
  let [e, n, r] = t, o, s, c;
  return isNaN(e) && (e = 0), isNaN(n) && (n = 0), e > 360 && (e -= 360), e < 0 && (e += 360), e /= 360, e < 1 / 3 ? (c = (1 - n) / 3, o = (1 + n * st(Z * e) / st(St - Z * e)) / 3, s = 1 - (c + o)) : e < 2 / 3 ? (e -= 1 / 3, o = (1 - n) / 3, s = (1 + n * st(Z * e) / st(St - Z * e)) / 3, c = 1 - (o + s)) : (e -= 2 / 3, s = (1 - n) / 3, c = (1 + n * st(Z * e) / st(St - Z * e)) / 3, o = 1 - (s + c)), o = nt(r * o * 3), s = nt(r * s * 3), c = nt(r * c * 3), [o * 255, s * 255, c * 255, t.length > 3 ? t[3] : 1];
}, { min: Xn, sqrt: Tn, acos: qn } = Math, Hn = (...t) => {
  let [e, n, r] = x(t, "rgb");
  e /= 255, n /= 255, r /= 255;
  let o;
  const s = Xn(e, n, r), c = (e + n + r) / 3, a = c > 0 ? 1 - s / c : 0;
  return a === 0 ? o = NaN : (o = (e - n + (e - r)) / 2, o /= Tn((e - n) * (e - n) + (e - r) * (n - r)), o = qn(o), r > n && (o = Z - o), o /= Z), [o * 360, a, c];
};
l.prototype.hsi = function() {
  return Hn(this._rgb);
};
const Zn = (...t) => new l(...t, "hsi");
$.hsi = Zn;
_.format.hsi = Dn;
_.autodetect.push({
  p: 2,
  test: (...t) => {
    if (t = x(t, "hsi"), C(t) === "array" && t.length === 3)
      return "hsi";
  }
});
const Wn = (t, e, n) => lt(t, e, n, "hsi");
B.hsi = Wn;
const Tt = (...t) => {
  t = x(t, "hsl");
  const [e, n, r] = t;
  let o, s, c;
  if (n === 0)
    o = s = c = r * 255;
  else {
    const a = [0, 0, 0], f = [0, 0, 0], i = r < 0.5 ? r * (1 + n) : r + n - r * n, h = 2 * r - i, d = e / 360;
    a[0] = d + 1 / 3, a[1] = d, a[2] = d - 1 / 3;
    for (let b = 0; b < 3; b++)
      a[b] < 0 && (a[b] += 1), a[b] > 1 && (a[b] -= 1), 6 * a[b] < 1 ? f[b] = h + (i - h) * 6 * a[b] : 2 * a[b] < 1 ? f[b] = i : 3 * a[b] < 2 ? f[b] = h + (i - h) * (2 / 3 - a[b]) * 6 : f[b] = h;
    [o, s, c] = [f[0] * 255, f[1] * 255, f[2] * 255];
  }
  return t.length > 3 ? [o, s, c, t[3]] : [o, s, c, 1];
}, ve = (...t) => {
  t = x(t, "rgba");
  let [e, n, r] = t;
  e /= 255, n /= 255, r /= 255;
  const o = ke(e, n, r), s = _e(e, n, r), c = (s + o) / 2;
  let a, f;
  return s === o ? (a = 0, f = Number.NaN) : a = c < 0.5 ? (s - o) / (s + o) : (s - o) / (2 - s - o), e == s ? f = (n - r) / (s - o) : n == s ? f = 2 + (r - e) / (s - o) : r == s && (f = 4 + (e - n) / (s - o)), f *= 60, f < 0 && (f += 360), t.length > 3 && t[3] !== void 0 ? [f, a, c, t[3]] : [f, a, c];
};
l.prototype.hsl = function() {
  return ve(this._rgb);
};
const Kn = (...t) => new l(...t, "hsl");
$.hsl = Kn;
_.format.hsl = Tt;
_.autodetect.push({
  p: 2,
  test: (...t) => {
    if (t = x(t, "hsl"), C(t) === "array" && t.length === 3)
      return "hsl";
  }
});
const Fn = (t, e, n) => lt(t, e, n, "hsl");
B.hsl = Fn;
const { floor: Un } = Math, Vn = (...t) => {
  t = x(t, "hsv");
  let [e, n, r] = t, o, s, c;
  if (r *= 255, n === 0)
    o = s = c = r;
  else {
    e === 360 && (e = 0), e > 360 && (e -= 360), e < 0 && (e += 360), e /= 60;
    const a = Un(e), f = e - a, i = r * (1 - n), h = r * (1 - n * f), d = r * (1 - n * (1 - f));
    switch (a) {
      case 0:
        [o, s, c] = [r, d, i];
        break;
      case 1:
        [o, s, c] = [h, r, i];
        break;
      case 2:
        [o, s, c] = [i, r, d];
        break;
      case 3:
        [o, s, c] = [i, h, r];
        break;
      case 4:
        [o, s, c] = [d, i, r];
        break;
      case 5:
        [o, s, c] = [r, i, h];
        break;
    }
  }
  return [o, s, c, t.length > 3 ? t[3] : 1];
}, { min: Jn, max: Qn } = Math, tr = (...t) => {
  t = x(t, "rgb");
  let [e, n, r] = t;
  const o = Jn(e, n, r), s = Qn(e, n, r), c = s - o;
  let a, f, i;
  return i = s / 255, s === 0 ? (a = Number.NaN, f = 0) : (f = c / s, e === s && (a = (n - r) / c), n === s && (a = 2 + (r - e) / c), r === s && (a = 4 + (e - n) / c), a *= 60, a < 0 && (a += 360)), [a, f, i];
};
l.prototype.hsv = function() {
  return tr(this._rgb);
};
const er = (...t) => new l(...t, "hsv");
$.hsv = er;
_.format.hsv = Vn;
_.autodetect.push({
  p: 2,
  test: (...t) => {
    if (t = x(t, "hsv"), C(t) === "array" && t.length === 3)
      return "hsv";
  }
});
const nr = (t, e, n) => lt(t, e, n, "hsv");
B.hsv = nr;
function Ct(t, e) {
  let n = t.length;
  Array.isArray(t[0]) || (t = [t]), Array.isArray(e[0]) || (e = e.map((c) => [c]));
  let r = e[0].length, o = e[0].map((c, a) => e.map((f) => f[a])), s = t.map(
    (c) => o.map((a) => Array.isArray(c) ? c.reduce((f, i, h) => f + i * (a[h] || 0), 0) : a.reduce((f, i) => f + i * c, 0))
  );
  return n === 1 && (s = s[0]), r === 1 ? s.map((c) => c[0]) : s;
}
const Jt = (...t) => {
  t = x(t, "lab");
  const [e, n, r, ...o] = t, [s, c, a] = rr([e, n, r]), [f, i, h] = Ce(s, c, a);
  return [f, i, h, ...o.length > 0 && o[0] < 1 ? [o[0]] : []];
};
function rr(t) {
  var e = [
    [1.2268798758459243, -0.5578149944602171, 0.2813910456659647],
    [-0.0405757452148008, 1.112286803280317, -0.0717110580655164],
    [-0.0763729366746601, -0.4214933324022432, 1.5869240198367816]
  ], n = [
    [1, 0.3963377773761749, 0.2158037573099136],
    [1, -0.1055613458156586, -0.0638541728258133],
    [1, -0.0894841775298119, -1.2914855480194092]
  ], r = Ct(n, t);
  return Ct(
    e,
    r.map((o) => o ** 3)
  );
}
const Qt = (...t) => {
  const [e, n, r, ...o] = x(t, "rgb"), s = Ee(e, n, r);
  return [...or(s), ...o.length > 0 && o[0] < 1 ? [o[0]] : []];
};
function or(t) {
  const e = [
    [0.819022437996703, 0.3619062600528904, -0.1288737815209879],
    [0.0329836539323885, 0.9292868615863434, 0.0361446663506424],
    [0.0481771893596242, 0.2642395317527308, 0.6335478284694309]
  ], n = [
    [0.210454268309314, 0.7936177747023054, -0.0040720430116193],
    [1.9779985324311684, -2.42859224204858, 0.450593709617411],
    [0.0259040424655478, 0.7827717124575296, -0.8086757549230774]
  ], r = Ct(e, t);
  return Ct(
    n,
    r.map((o) => Math.cbrt(o))
  );
}
l.prototype.oklab = function() {
  return Qt(this._rgb);
};
const sr = (...t) => new l(...t, "oklab");
Object.assign($, { oklab: sr });
_.format.oklab = Jt;
_.autodetect.push({
  p: 2,
  test: (...t) => {
    if (t = x(t, "oklab"), C(t) === "array" && t.length === 3)
      return "oklab";
  }
});
const cr = (t, e, n) => {
  const r = t.oklab(), o = e.oklab();
  return new l(
    r[0] + n * (o[0] - r[0]),
    r[1] + n * (o[1] - r[1]),
    r[2] + n * (o[2] - r[2]),
    "oklab"
  );
};
B.oklab = cr;
const ar = (t, e, n) => lt(t, e, n, "oklch");
B.oklch = ar;
const { pow: Bt, sqrt: zt, PI: Gt, cos: se, sin: ce, atan2: fr } = Math, ir = (t, e = "lrgb", n = null) => {
  const r = t.length;
  n || (n = Array.from(new Array(r)).map(() => 1));
  const o = r / n.reduce(function(d, b) {
    return d + b;
  });
  if (n.forEach((d, b) => {
    n[b] *= o;
  }), t = t.map((d) => new l(d)), e === "lrgb")
    return lr(t, n);
  const s = t.shift(), c = s.get(e), a = [];
  let f = 0, i = 0;
  for (let d = 0; d < c.length; d++)
    if (c[d] = (c[d] || 0) * n[0], a.push(isNaN(c[d]) ? 0 : n[0]), e.charAt(d) === "h" && !isNaN(c[d])) {
      const b = c[d] / 180 * Gt;
      f += se(b) * n[0], i += ce(b) * n[0];
    }
  let h = s.alpha() * n[0];
  t.forEach((d, b) => {
    const g = d.get(e);
    h += d.alpha() * n[b + 1];
    for (let k = 0; k < c.length; k++)
      if (!isNaN(g[k]))
        if (a[k] += n[b + 1], e.charAt(k) === "h") {
          const R = g[k] / 180 * Gt;
          f += se(R) * n[b + 1], i += ce(R) * n[b + 1];
        } else
          c[k] += g[k] * n[b + 1];
  });
  for (let d = 0; d < c.length; d++)
    if (e.charAt(d) === "h") {
      let b = fr(i / a[d], f / a[d]) / Gt * 180;
      for (; b < 0; ) b += 360;
      for (; b >= 360; ) b -= 360;
      c[d] = b;
    } else
      c[d] = c[d] / a[d];
  return h /= r, new l(c, e).alpha(h > 0.99999 ? 1 : h, !0);
}, lr = (t, e) => {
  const n = t.length, r = [0, 0, 0, 0];
  for (let o = 0; o < t.length; o++) {
    const s = t[o], c = e[o] / n, a = s._rgb;
    r[0] += Bt(a[0], 2) * c, r[1] += Bt(a[1], 2) * c, r[2] += Bt(a[2], 2) * c, r[3] += a[3] * c;
  }
  return r[0] = zt(r[0]), r[1] = zt(r[1]), r[2] = zt(r[2]), r[3] > 0.9999999 && (r[3] = 1), new l(Wt(r));
}, { pow: ur } = Math;
function Et(t) {
  let e = "rgb", n = $("#ccc"), r = 0, o = [0, 1], s = [], c = [0, 0], a = !1, f = [], i = !1, h = 0, d = 1, b = !1, g = {}, k = !0, R = 1;
  const p = function(u) {
    if (u = u || ["#fff", "#000"], u && C(u) === "string" && $.brewer && $.brewer[u.toLowerCase()] && (u = $.brewer[u.toLowerCase()]), C(u) === "array") {
      u.length === 1 && (u = [u[0], u[0]]), u = u.slice(0);
      for (let m = 0; m < u.length; m++)
        u[m] = $(u[m]);
      s.length = 0;
      for (let m = 0; m < u.length; m++)
        s.push(m / (u.length - 1));
    }
    return O(), f = u;
  }, w = function(u) {
    if (a != null) {
      const m = a.length - 1;
      let M = 0;
      for (; M < m && u >= a[M]; )
        M++;
      return M - 1;
    }
    return 0;
  };
  let j = (u) => u, I = (u) => u;
  const N = function(u, m) {
    let M, y;
    if (m == null && (m = !1), isNaN(u) || u === null)
      return n;
    m ? y = u : a && a.length > 2 ? y = w(u) / (a.length - 2) : d !== h ? y = (u - h) / (d - h) : y = 1, y = I(y), m || (y = j(y)), R !== 1 && (y = ur(y, R)), y = c[0] + y * (1 - c[0] - c[1]), y = nt(y, 0, 1);
    const L = Math.floor(y * 1e4);
    if (k && g[L])
      M = g[L];
    else {
      if (C(f) === "array")
        for (let A = 0; A < s.length; A++) {
          const v = s[A];
          if (y <= v) {
            M = f[A];
            break;
          }
          if (y >= v && A === s.length - 1) {
            M = f[A];
            break;
          }
          if (y > v && y < s[A + 1]) {
            y = (y - v) / (s[A + 1] - v), M = $.interpolate(
              f[A],
              f[A + 1],
              y,
              e
            );
            break;
          }
        }
      else C(f) === "function" && (M = f(y));
      k && (g[L] = M);
    }
    return M;
  };
  var O = () => g = {};
  p(t);
  const E = function(u) {
    const m = $(N(u));
    return i && m[i] ? m[i]() : m;
  };
  return E.classes = function(u) {
    if (u != null) {
      if (C(u) === "array")
        a = u, o = [u[0], u[u.length - 1]];
      else {
        const m = $.analyze(o);
        u === 0 ? a = [m.min, m.max] : a = $.limits(m, "e", u);
      }
      return E;
    }
    return a;
  }, E.domain = function(u) {
    if (!arguments.length)
      return o;
    h = u[0], d = u[u.length - 1], s = [];
    const m = f.length;
    if (u.length === m && h !== d)
      for (let M of Array.from(u))
        s.push((M - h) / (d - h));
    else {
      for (let M = 0; M < m; M++)
        s.push(M / (m - 1));
      if (u.length > 2) {
        const M = u.map((L, A) => A / (u.length - 1)), y = u.map((L) => (L - h) / (d - h));
        y.every((L, A) => M[A] === L) || (I = (L) => {
          if (L <= 0 || L >= 1) return L;
          let A = 0;
          for (; L >= y[A + 1]; ) A++;
          const v = (L - y[A]) / (y[A + 1] - y[A]);
          return M[A] + v * (M[A + 1] - M[A]);
        });
      }
    }
    return o = [h, d], E;
  }, E.mode = function(u) {
    return arguments.length ? (e = u, O(), E) : e;
  }, E.range = function(u, m) {
    return p(u), E;
  }, E.out = function(u) {
    return i = u, E;
  }, E.spread = function(u) {
    return arguments.length ? (r = u, E) : r;
  }, E.correctLightness = function(u) {
    return u == null && (u = !0), b = u, O(), b ? j = function(m) {
      const M = N(0, !0).lab()[0], y = N(1, !0).lab()[0], L = M > y;
      let A = N(m, !0).lab()[0];
      const v = M + (y - M) * m;
      let J = A - v, bt = 0, mt = 1, pt = 20;
      for (; Math.abs(J) > 0.01 && pt-- > 0; )
        (function() {
          return L && (J *= -1), J < 0 ? (bt = m, m += (mt - m) * 0.5) : (mt = m, m += (bt - m) * 0.5), A = N(m, !0).lab()[0], J = A - v;
        })();
      return m;
    } : j = (m) => m, E;
  }, E.padding = function(u) {
    return u != null ? (C(u) === "number" && (u = [u, u]), c = u, E) : c;
  }, E.colors = function(u, m) {
    arguments.length < 2 && (m = "hex");
    let M = [];
    if (arguments.length === 0)
      M = f.slice(0);
    else if (u === 1)
      M = [E(0.5)];
    else if (u > 1) {
      const y = o[0], L = o[1] - y;
      M = hr(0, u).map(
        (A) => E(y + A / (u - 1) * L)
      );
    } else {
      t = [];
      let y = [];
      if (a && a.length > 2)
        for (let L = 1, A = a.length, v = 1 <= A; v ? L < A : L > A; v ? L++ : L--)
          y.push((a[L - 1] + a[L]) * 0.5);
      else
        y = o;
      M = y.map((L) => E(L));
    }
    return $[m] && (M = M.map((y) => y[m]())), M;
  }, E.cache = function(u) {
    return u != null ? (k = u, E) : k;
  }, E.gamma = function(u) {
    return u != null ? (R = u, E) : R;
  }, E.nodata = function(u) {
    return u != null ? (n = $(u), E) : n;
  }, E;
}
function hr(t, e, n) {
  let r = [], o = t < e, s = e;
  for (let c = t; o ? c < s : c > s; o ? c++ : c--)
    r.push(c);
  return r;
}
const br = function(t) {
  let e = [1, 1];
  for (let n = 1; n < t; n++) {
    let r = [1];
    for (let o = 1; o <= e.length; o++)
      r[o] = (e[o] || 0) + e[o - 1];
    e = r;
  }
  return e;
}, dr = function(t) {
  let e, n, r, o;
  if (t = t.map((s) => new l(s)), t.length === 2)
    [n, r] = t.map((s) => s.lab()), e = function(s) {
      const c = [0, 1, 2].map((a) => n[a] + s * (r[a] - n[a]));
      return new l(c, "lab");
    };
  else if (t.length === 3)
    [n, r, o] = t.map((s) => s.lab()), e = function(s) {
      const c = [0, 1, 2].map(
        (a) => (1 - s) * (1 - s) * n[a] + 2 * (1 - s) * s * r[a] + s * s * o[a]
      );
      return new l(c, "lab");
    };
  else if (t.length === 4) {
    let s;
    [n, r, o, s] = t.map((c) => c.lab()), e = function(c) {
      const a = [0, 1, 2].map(
        (f) => (1 - c) * (1 - c) * (1 - c) * n[f] + 3 * (1 - c) * (1 - c) * c * r[f] + 3 * (1 - c) * c * c * o[f] + c * c * c * s[f]
      );
      return new l(a, "lab");
    };
  } else if (t.length >= 5) {
    let s, c, a;
    s = t.map((f) => f.lab()), a = t.length - 1, c = br(a), e = function(f) {
      const i = 1 - f, h = [0, 1, 2].map(
        (d) => s.reduce(
          (b, g, k) => b + c[k] * i ** (a - k) * f ** k * g[d],
          0
        )
      );
      return new l(h, "lab");
    };
  } else
    throw new RangeError("No point in running bezier with only one color.");
  return e;
}, gr = (t) => {
  const e = dr(t);
  return e.scale = () => Et(e), e;
}, { round: Ne } = Math;
l.prototype.rgb = function(t = !0) {
  return t === !1 ? this._rgb.slice(0, 3) : this._rgb.slice(0, 3).map(Ne);
};
l.prototype.rgba = function(t = !0) {
  return this._rgb.slice(0, 4).map((e, n) => n < 3 ? t === !1 ? e : Ne(e) : e);
};
const mr = (...t) => new l(...t, "rgb");
Object.assign($, { rgb: mr });
_.format.rgb = (...t) => {
  const e = x(t, "rgba");
  return e[3] === void 0 && (e[3] = 1), e;
};
_.autodetect.push({
  p: 3,
  test: (...t) => {
    if (t = x(t, "rgba"), C(t) === "array" && (t.length === 3 || t.length === 4 && C(t[3]) == "number" && t[3] >= 0 && t[3] <= 1))
      return "rgb";
  }
});
const T = (t, e, n) => {
  if (!T[n])
    throw new Error("unknown blend mode " + n);
  return T[n](t, e);
}, U = (t) => (e, n) => {
  const r = $(n).rgb(), o = $(e).rgb();
  return $.rgb(t(r, o));
}, V = (t) => (e, n) => {
  const r = [];
  return r[0] = t(e[0], n[0]), r[1] = t(e[1], n[1]), r[2] = t(e[2], n[2]), r;
}, pr = (t) => t, wr = (t, e) => t * e / 255, yr = (t, e) => t > e ? e : t, kr = (t, e) => t > e ? t : e, _r = (t, e) => 255 * (1 - (1 - t / 255) * (1 - e / 255)), xr = (t, e) => e < 128 ? 2 * t * e / 255 : 255 * (1 - 2 * (1 - t / 255) * (1 - e / 255)), Mr = (t, e) => 255 * (1 - (1 - e / 255) / (t / 255)), $r = (t, e) => t === 255 ? 255 : (t = 255 * (e / 255) / (1 - t / 255), t > 255 ? 255 : t);
T.normal = U(V(pr));
T.multiply = U(V(wr));
T.screen = U(V(_r));
T.overlay = U(V(xr));
T.darken = U(V(yr));
T.lighten = U(V(kr));
T.dodge = U(V($r));
T.burn = U(V(Mr));
const { pow: Cr, sin: Er, cos: Ar } = Math;
function Lr(t = 300, e = -1.5, n = 1, r = 1, o = [0, 1]) {
  let s = 0, c;
  C(o) === "array" ? c = o[1] - o[0] : (c = 0, o = [o, o]);
  const a = function(f) {
    const i = Z * ((t + 120) / 360 + e * f), h = Cr(o[0] + c * f, r), b = (s !== 0 ? n[0] + f * s : n) * h * (1 - h) / 2, g = Ar(i), k = Er(i), R = h + b * (-0.14861 * g + 1.78277 * k), p = h + b * (-0.29227 * g - 0.90649 * k), w = h + b * (1.97294 * g);
    return $(Wt([R * 255, p * 255, w * 255, 1]));
  };
  return a.start = function(f) {
    return f == null ? t : (t = f, a);
  }, a.rotations = function(f) {
    return f == null ? e : (e = f, a);
  }, a.gamma = function(f) {
    return f == null ? r : (r = f, a);
  }, a.hue = function(f) {
    return f == null ? n : (n = f, C(n) === "array" ? (s = n[1] - n[0], s === 0 && (n = n[1])) : s = 0, a);
  }, a.lightness = function(f) {
    return f == null ? o : (C(f) === "array" ? (o = f, c = f[1] - f[0]) : (o = [f, f], c = 0), a);
  }, a.scale = () => $.scale(a), a.hue(n), a;
}
const Rr = "0123456789abcdef", { floor: vr, random: Nr } = Math, Sr = () => {
  let t = "#";
  for (let e = 0; e < 6; e++)
    t += Rr.charAt(vr(Nr() * 16));
  return new l(t, "hex");
}, { log: ae, pow: Pr, floor: jr, abs: Ir } = Math;
function Se(t, e = null) {
  const n = {
    min: Number.MAX_VALUE,
    max: Number.MAX_VALUE * -1,
    sum: 0,
    values: [],
    count: 0
  };
  return C(t) === "object" && (t = Object.values(t)), t.forEach((r) => {
    e && C(r) === "object" && (r = r[e]), r != null && !isNaN(r) && (n.values.push(r), n.sum += r, r < n.min && (n.min = r), r > n.max && (n.max = r), n.count += 1);
  }), n.domain = [n.min, n.max], n.limits = (r, o) => Pe(n, r, o), n;
}
function Pe(t, e = "equal", n = 7) {
  C(t) == "array" && (t = Se(t));
  const { min: r, max: o } = t, s = t.values.sort((a, f) => a - f);
  if (n === 1)
    return [r, o];
  const c = [];
  if (e.substr(0, 1) === "c" && (c.push(r), c.push(o)), e.substr(0, 1) === "e") {
    c.push(r);
    for (let a = 1; a < n; a++)
      c.push(r + a / n * (o - r));
    c.push(o);
  } else if (e.substr(0, 1) === "l") {
    if (r <= 0)
      throw new Error(
        "Logarithmic scales are only possible for values > 0"
      );
    const a = Math.LOG10E * ae(r), f = Math.LOG10E * ae(o);
    c.push(r);
    for (let i = 1; i < n; i++)
      c.push(Pr(10, a + i / n * (f - a)));
    c.push(o);
  } else if (e.substr(0, 1) === "q") {
    c.push(r);
    for (let a = 1; a < n; a++) {
      const f = (s.length - 1) * a / n, i = jr(f);
      if (i === f)
        c.push(s[i]);
      else {
        const h = f - i;
        c.push(s[i] * (1 - h) + s[i + 1] * h);
      }
    }
    c.push(o);
  } else if (e.substr(0, 1) === "k") {
    let a;
    const f = s.length, i = new Array(f), h = new Array(n);
    let d = !0, b = 0, g = null;
    g = [], g.push(r);
    for (let p = 1; p < n; p++)
      g.push(r + p / n * (o - r));
    for (g.push(o); d; ) {
      for (let w = 0; w < n; w++)
        h[w] = 0;
      for (let w = 0; w < f; w++) {
        const j = s[w];
        let I = Number.MAX_VALUE, N;
        for (let O = 0; O < n; O++) {
          const E = Ir(g[O] - j);
          E < I && (I = E, N = O), h[N]++, i[w] = N;
        }
      }
      const p = new Array(n);
      for (let w = 0; w < n; w++)
        p[w] = null;
      for (let w = 0; w < f; w++)
        a = i[w], p[a] === null ? p[a] = s[w] : p[a] += s[w];
      for (let w = 0; w < n; w++)
        p[w] *= 1 / h[w];
      d = !1;
      for (let w = 0; w < n; w++)
        if (p[w] !== g[w]) {
          d = !0;
          break;
        }
      g = p, b++, b > 200 && (d = !1);
    }
    const k = {};
    for (let p = 0; p < n; p++)
      k[p] = [];
    for (let p = 0; p < f; p++)
      a = i[p], k[a].push(s[p]);
    let R = [];
    for (let p = 0; p < n; p++)
      R.push(k[p][0]), R.push(k[p][k[p].length - 1]);
    R = R.sort((p, w) => p - w), c.push(R[0]);
    for (let p = 1; p < R.length; p += 2) {
      const w = R[p];
      !isNaN(w) && c.indexOf(w) === -1 && c.push(w);
    }
  }
  return c;
}
const Or = (t, e) => {
  t = new l(t), e = new l(e);
  const n = t.luminance(), r = e.luminance();
  return n > r ? (n + 0.05) / (r + 0.05) : (r + 0.05) / (n + 0.05);
};
/**
 * @license
 *
 * The APCA contrast prediction algorithm is based of the formulas published
 * in the APCA-1.0.98G specification by Myndex. The specification is available at:
 * https://raw.githubusercontent.com/Myndex/apca-w3/master/images/APCAw3_0.1.17_APCA0.0.98G.svg
 *
 * Note that the APCA implementation is still beta, so please update to
 * future versions of chroma.js when they become available.
 *
 * You can read more about the APCA Readability Criterion at
 * https://readtech.org/ARC/
 */
const fe = 0.027, Br = 5e-4, zr = 0.1, ie = 1.14, _t = 0.022, le = 1.414, Gr = (t, e) => {
  t = new l(t), e = new l(e), t.alpha() < 1 && (t = ft(e, t, t.alpha(), "rgb"));
  const n = ue(...t.rgb()), r = ue(...e.rgb()), o = n >= _t ? n : n + Math.pow(_t - n, le), s = r >= _t ? r : r + Math.pow(_t - r, le), c = Math.pow(s, 0.56) - Math.pow(o, 0.57), a = Math.pow(s, 0.65) - Math.pow(o, 0.62), f = Math.abs(s - o) < Br ? 0 : o < s ? c * ie : a * ie;
  return (Math.abs(f) < zr ? 0 : f > 0 ? f - fe : f + fe) * 100;
};
function ue(t, e, n) {
  return 0.2126729 * Math.pow(t / 255, 2.4) + 0.7151522 * Math.pow(e / 255, 2.4) + 0.072175 * Math.pow(n / 255, 2.4);
}
const { sqrt: H, pow: S, min: Yr, max: Dr, atan2: he, abs: be, cos: xt, sin: de, exp: Xr, PI: ge } = Math;
function Tr(t, e, n = 1, r = 1, o = 1) {
  var s = function(vt) {
    return 360 * vt / (2 * ge);
  }, c = function(vt) {
    return 2 * ge * vt / 360;
  };
  t = new l(t), e = new l(e);
  const [a, f, i] = Array.from(t.lab()), [h, d, b] = Array.from(e.lab()), g = (a + h) / 2, k = H(S(f, 2) + S(i, 2)), R = H(S(d, 2) + S(b, 2)), p = (k + R) / 2, w = 0.5 * (1 - H(S(p, 7) / (S(p, 7) + S(25, 7)))), j = f * (1 + w), I = d * (1 + w), N = H(S(j, 2) + S(i, 2)), O = H(S(I, 2) + S(b, 2)), E = (N + O) / 2, u = s(he(i, j)), m = s(he(b, I)), M = u >= 0 ? u : u + 360, y = m >= 0 ? m : m + 360, L = be(M - y) > 180 ? (M + y + 360) / 2 : (M + y) / 2, A = 1 - 0.17 * xt(c(L - 30)) + 0.24 * xt(c(2 * L)) + 0.32 * xt(c(3 * L + 6)) - 0.2 * xt(c(4 * L - 63));
  let v = y - M;
  v = be(v) <= 180 ? v : y <= M ? v + 360 : v - 360, v = 2 * H(N * O) * de(c(v) / 2);
  const J = h - a, bt = O - N, mt = 1 + 0.015 * S(g - 50, 2) / H(20 + S(g - 50, 2)), pt = 1 + 0.045 * E, ne = 1 + 0.015 * E * A, Ve = 30 * Xr(-S((L - 275) / 25, 2)), Je = -(2 * H(S(E, 7) / (S(E, 7) + S(25, 7)))) * de(2 * c(Ve)), Qe = H(
    S(J / (n * mt), 2) + S(bt / (r * pt), 2) + S(v / (o * ne), 2) + Je * (bt / (r * pt)) * (v / (o * ne))
  );
  return Dr(0, Yr(100, Qe));
}
function qr(t, e, n = "lab") {
  t = new l(t), e = new l(e);
  const r = t.get(n), o = e.get(n);
  let s = 0;
  for (let c in r) {
    const a = (r[c] || 0) - (o[c] || 0);
    s += a * a;
  }
  return Math.sqrt(s);
}
const Hr = (...t) => {
  try {
    return new l(...t), !0;
  } catch {
    return !1;
  }
}, Zr = {
  cool() {
    return Et([$.hsl(180, 1, 0.9), $.hsl(250, 0.7, 0.4)]);
  },
  hot() {
    return Et(["#000", "#f00", "#ff0", "#fff"]).mode(
      "rgb"
    );
  }
}, qt = {
  // sequential
  OrRd: ["#fff7ec", "#fee8c8", "#fdd49e", "#fdbb84", "#fc8d59", "#ef6548", "#d7301f", "#b30000", "#7f0000"],
  PuBu: ["#fff7fb", "#ece7f2", "#d0d1e6", "#a6bddb", "#74a9cf", "#3690c0", "#0570b0", "#045a8d", "#023858"],
  BuPu: ["#f7fcfd", "#e0ecf4", "#bfd3e6", "#9ebcda", "#8c96c6", "#8c6bb1", "#88419d", "#810f7c", "#4d004b"],
  Oranges: ["#fff5eb", "#fee6ce", "#fdd0a2", "#fdae6b", "#fd8d3c", "#f16913", "#d94801", "#a63603", "#7f2704"],
  BuGn: ["#f7fcfd", "#e5f5f9", "#ccece6", "#99d8c9", "#66c2a4", "#41ae76", "#238b45", "#006d2c", "#00441b"],
  YlOrBr: ["#ffffe5", "#fff7bc", "#fee391", "#fec44f", "#fe9929", "#ec7014", "#cc4c02", "#993404", "#662506"],
  YlGn: ["#ffffe5", "#f7fcb9", "#d9f0a3", "#addd8e", "#78c679", "#41ab5d", "#238443", "#006837", "#004529"],
  Reds: ["#fff5f0", "#fee0d2", "#fcbba1", "#fc9272", "#fb6a4a", "#ef3b2c", "#cb181d", "#a50f15", "#67000d"],
  RdPu: ["#fff7f3", "#fde0dd", "#fcc5c0", "#fa9fb5", "#f768a1", "#dd3497", "#ae017e", "#7a0177", "#49006a"],
  Greens: ["#f7fcf5", "#e5f5e0", "#c7e9c0", "#a1d99b", "#74c476", "#41ab5d", "#238b45", "#006d2c", "#00441b"],
  YlGnBu: ["#ffffd9", "#edf8b1", "#c7e9b4", "#7fcdbb", "#41b6c4", "#1d91c0", "#225ea8", "#253494", "#081d58"],
  Purples: ["#fcfbfd", "#efedf5", "#dadaeb", "#bcbddc", "#9e9ac8", "#807dba", "#6a51a3", "#54278f", "#3f007d"],
  GnBu: ["#f7fcf0", "#e0f3db", "#ccebc5", "#a8ddb5", "#7bccc4", "#4eb3d3", "#2b8cbe", "#0868ac", "#084081"],
  Greys: ["#ffffff", "#f0f0f0", "#d9d9d9", "#bdbdbd", "#969696", "#737373", "#525252", "#252525", "#000000"],
  YlOrRd: ["#ffffcc", "#ffeda0", "#fed976", "#feb24c", "#fd8d3c", "#fc4e2a", "#e31a1c", "#bd0026", "#800026"],
  PuRd: ["#f7f4f9", "#e7e1ef", "#d4b9da", "#c994c7", "#df65b0", "#e7298a", "#ce1256", "#980043", "#67001f"],
  Blues: ["#f7fbff", "#deebf7", "#c6dbef", "#9ecae1", "#6baed6", "#4292c6", "#2171b5", "#08519c", "#08306b"],
  PuBuGn: ["#fff7fb", "#ece2f0", "#d0d1e6", "#a6bddb", "#67a9cf", "#3690c0", "#02818a", "#016c59", "#014636"],
  Viridis: ["#440154", "#482777", "#3f4a8a", "#31678e", "#26838f", "#1f9d8a", "#6cce5a", "#b6de2b", "#fee825"],
  // diverging
  Spectral: ["#9e0142", "#d53e4f", "#f46d43", "#fdae61", "#fee08b", "#ffffbf", "#e6f598", "#abdda4", "#66c2a5", "#3288bd", "#5e4fa2"],
  RdYlGn: ["#a50026", "#d73027", "#f46d43", "#fdae61", "#fee08b", "#ffffbf", "#d9ef8b", "#a6d96a", "#66bd63", "#1a9850", "#006837"],
  RdBu: ["#67001f", "#b2182b", "#d6604d", "#f4a582", "#fddbc7", "#f7f7f7", "#d1e5f0", "#92c5de", "#4393c3", "#2166ac", "#053061"],
  PiYG: ["#8e0152", "#c51b7d", "#de77ae", "#f1b6da", "#fde0ef", "#f7f7f7", "#e6f5d0", "#b8e186", "#7fbc41", "#4d9221", "#276419"],
  PRGn: ["#40004b", "#762a83", "#9970ab", "#c2a5cf", "#e7d4e8", "#f7f7f7", "#d9f0d3", "#a6dba0", "#5aae61", "#1b7837", "#00441b"],
  RdYlBu: ["#a50026", "#d73027", "#f46d43", "#fdae61", "#fee090", "#ffffbf", "#e0f3f8", "#abd9e9", "#74add1", "#4575b4", "#313695"],
  BrBG: ["#543005", "#8c510a", "#bf812d", "#dfc27d", "#f6e8c3", "#f5f5f5", "#c7eae5", "#80cdc1", "#35978f", "#01665e", "#003c30"],
  RdGy: ["#67001f", "#b2182b", "#d6604d", "#f4a582", "#fddbc7", "#ffffff", "#e0e0e0", "#bababa", "#878787", "#4d4d4d", "#1a1a1a"],
  PuOr: ["#7f3b08", "#b35806", "#e08214", "#fdb863", "#fee0b6", "#f7f7f7", "#d8daeb", "#b2abd2", "#8073ac", "#542788", "#2d004b"],
  // qualitative
  Set2: ["#66c2a5", "#fc8d62", "#8da0cb", "#e78ac3", "#a6d854", "#ffd92f", "#e5c494", "#b3b3b3"],
  Accent: ["#7fc97f", "#beaed4", "#fdc086", "#ffff99", "#386cb0", "#f0027f", "#bf5b17", "#666666"],
  Set1: ["#e41a1c", "#377eb8", "#4daf4a", "#984ea3", "#ff7f00", "#ffff33", "#a65628", "#f781bf", "#999999"],
  Set3: ["#8dd3c7", "#ffffb3", "#bebada", "#fb8072", "#80b1d3", "#fdb462", "#b3de69", "#fccde5", "#d9d9d9", "#bc80bd", "#ccebc5", "#ffed6f"],
  Dark2: ["#1b9e77", "#d95f02", "#7570b3", "#e7298a", "#66a61e", "#e6ab02", "#a6761d", "#666666"],
  Paired: ["#a6cee3", "#1f78b4", "#b2df8a", "#33a02c", "#fb9a99", "#e31a1c", "#fdbf6f", "#ff7f00", "#cab2d6", "#6a3d9a", "#ffff99", "#b15928"],
  Pastel2: ["#b3e2cd", "#fdcdac", "#cbd5e8", "#f4cae4", "#e6f5c9", "#fff2ae", "#f1e2cc", "#cccccc"],
  Pastel1: ["#fbb4ae", "#b3cde3", "#ccebc5", "#decbe4", "#fed9a6", "#ffffcc", "#e5d8bd", "#fddaec", "#f2f2f2"]
}, je = Object.keys(qt), me = new Map(je.map((t) => [t.toLowerCase(), t])), Wr = typeof Proxy == "function" ? new Proxy(qt, {
  get(t, e) {
    const n = e.toLowerCase();
    if (me.has(n))
      return t[me.get(n)];
  },
  getOwnPropertyNames() {
    return Object.getOwnPropertyNames(je);
  }
}) : qt, Kr = (...t) => {
  t = x(t, "cmyk");
  const [e, n, r, o] = t, s = t.length > 4 ? t[4] : 1;
  return o === 1 ? [0, 0, 0, s] : [
    e >= 1 ? 0 : 255 * (1 - e) * (1 - o),
    // r
    n >= 1 ? 0 : 255 * (1 - n) * (1 - o),
    // g
    r >= 1 ? 0 : 255 * (1 - r) * (1 - o),
    // b
    s
  ];
}, { max: pe } = Math, Fr = (...t) => {
  let [e, n, r] = x(t, "rgb");
  e = e / 255, n = n / 255, r = r / 255;
  const o = 1 - pe(e, pe(n, r)), s = o < 1 ? 1 / (1 - o) : 0, c = (1 - e - o) * s, a = (1 - n - o) * s, f = (1 - r - o) * s;
  return [c, a, f, o];
};
l.prototype.cmyk = function() {
  return Fr(this._rgb);
};
const Ur = (...t) => new l(...t, "cmyk");
Object.assign($, { cmyk: Ur });
_.format.cmyk = Kr;
_.autodetect.push({
  p: 2,
  test: (...t) => {
    if (t = x(t, "cmyk"), C(t) === "array" && t.length === 4)
      return "cmyk";
  }
});
const Vr = (...t) => {
  const e = x(t, "hsla");
  let n = it(t) || "lsa";
  return e[0] = Y(e[0] || 0) + "deg", e[1] = Y(e[1] * 100) + "%", e[2] = Y(e[2] * 100) + "%", n === "hsla" || e.length > 3 && e[3] < 1 ? (e[3] = "/ " + (e.length > 3 ? e[3] : 1), n = "hsla") : e.length = 3, `${n.substr(0, 3)}(${e.join(" ")})`;
}, Jr = (...t) => {
  const e = x(t, "lab");
  let n = it(t) || "lab";
  return e[0] = Y(e[0]) + "%", e[1] = Y(e[1]), e[2] = Y(e[2]), n === "laba" || e.length > 3 && e[3] < 1 ? e[3] = "/ " + (e.length > 3 ? e[3] : 1) : e.length = 3, `lab(${e.join(" ")})`;
}, Qr = (...t) => {
  const e = x(t, "lch");
  let n = it(t) || "lab";
  return e[0] = Y(e[0]) + "%", e[1] = Y(e[1]), e[2] = isNaN(e[2]) ? "none" : Y(e[2]) + "deg", n === "lcha" || e.length > 3 && e[3] < 1 ? e[3] = "/ " + (e.length > 3 ? e[3] : 1) : e.length = 3, `lch(${e.join(" ")})`;
}, t0 = (...t) => {
  const e = x(t, "lab");
  return e[0] = Y(e[0] * 100) + "%", e[1] = Xt(e[1]), e[2] = Xt(e[2]), e.length > 3 && e[3] < 1 ? e[3] = "/ " + (e.length > 3 ? e[3] : 1) : e.length = 3, `oklab(${e.join(" ")})`;
}, Ie = (...t) => {
  const [e, n, r, ...o] = x(t, "rgb"), [s, c, a] = Qt(e, n, r), [f, i, h] = Le(s, c, a);
  return [f, i, h, ...o.length > 0 && o[0] < 1 ? [o[0]] : []];
}, e0 = (...t) => {
  const e = x(t, "lch");
  return e[0] = Y(e[0] * 100) + "%", e[1] = Xt(e[1]), e[2] = isNaN(e[2]) ? "none" : Y(e[2]) + "deg", e.length > 3 && e[3] < 1 ? e[3] = "/ " + (e.length > 3 ? e[3] : 1) : e.length = 3, `oklch(${e.join(" ")})`;
}, { round: Yt } = Math, n0 = (...t) => {
  const e = x(t, "rgba");
  let n = it(t) || "rgb";
  if (n.substr(0, 3) === "hsl")
    return Vr(ve(e), n);
  if (n.substr(0, 3) === "lab") {
    const r = gt();
    W("d50");
    const o = Jr(Ft(e), n);
    return W(r), o;
  }
  if (n.substr(0, 3) === "lch") {
    const r = gt();
    W("d50");
    const o = Qr(Vt(e), n);
    return W(r), o;
  }
  return n.substr(0, 5) === "oklab" ? t0(Qt(e)) : n.substr(0, 5) === "oklch" ? e0(Ie(e)) : (e[0] = Yt(e[0]), e[1] = Yt(e[1]), e[2] = Yt(e[2]), (n === "rgba" || e.length > 3 && e[3] < 1) && (e[3] = "/ " + (e.length > 3 ? e[3] : 1), n = "rgba"), `${n.substr(0, 3)}(${e.slice(0, n === "rgb" ? 3 : 4).join(" ")})`);
}, Oe = (...t) => {
  t = x(t, "lch");
  const [e, n, r, ...o] = t, [s, c, a] = Ae(e, n, r), [f, i, h] = Jt(s, c, a);
  return [f, i, h, ...o.length > 0 && o[0] < 1 ? [o[0]] : []];
}, K = /((?:-?\d+)|(?:-?\d+(?:\.\d+)?)%|none)/.source, X = /((?:-?(?:\d+(?:\.\d*)?|\.\d+)%?)|none)/.source, At = /((?:-?(?:\d+(?:\.\d*)?|\.\d+)%)|none)/.source, D = /\s*/.source, ut = /\s+/.source, te = /\s*,\s*/.source, Rt = /((?:-?(?:\d+(?:\.\d*)?|\.\d+)(?:deg)?)|none)/.source, ht = /\s*(?:\/\s*((?:[01]|[01]?\.\d+)|\d+(?:\.\d+)?%))?/.source, Be = new RegExp(
  "^rgba?\\(" + D + [K, K, K].join(ut) + ht + "\\)$"
), ze = new RegExp(
  "^rgb\\(" + D + [K, K, K].join(te) + D + "\\)$"
), Ge = new RegExp(
  "^rgba\\(" + D + [K, K, K, X].join(te) + D + "\\)$"
), Ye = new RegExp(
  "^hsla?\\(" + D + [Rt, At, At].join(ut) + ht + "\\)$"
), De = new RegExp(
  "^hsl?\\(" + D + [Rt, At, At].join(te) + D + "\\)$"
), Xe = /^hsla\(\s*(-?\d+(?:\.\d+)?),\s*(-?\d+(?:\.\d+)?)%\s*,\s*(-?\d+(?:\.\d+)?)%\s*,\s*([01]|[01]?\.\d+)\)$/, Te = new RegExp(
  "^lab\\(" + D + [X, X, X].join(ut) + ht + "\\)$"
), qe = new RegExp(
  "^lch\\(" + D + [X, X, Rt].join(ut) + ht + "\\)$"
), He = new RegExp(
  "^oklab\\(" + D + [X, X, X].join(ut) + ht + "\\)$"
), Ze = new RegExp(
  "^oklch\\(" + D + [X, X, Rt].join(ut) + ht + "\\)$"
), { round: We } = Math, ct = (t) => t.map((e, n) => n <= 2 ? nt(We(e), 0, 255) : e), P = (t, e = 0, n = 100, r = !1) => (typeof t == "string" && t.endsWith("%") && (t = parseFloat(t.substring(0, t.length - 1)) / 100, r ? t = e + (t + 1) * 0.5 * (n - e) : t = e + t * (n - e)), +t), G = (t, e) => t === "none" ? e : t, ee = (t) => {
  if (t = t.toLowerCase().trim(), t === "transparent")
    return [0, 0, 0, 0];
  let e;
  if (_.format.named)
    try {
      return _.format.named(t);
    } catch {
    }
  if ((e = t.match(Be)) || (e = t.match(ze))) {
    let n = e.slice(1, 4);
    for (let o = 0; o < 3; o++)
      n[o] = +P(G(n[o], 0), 0, 255);
    n = ct(n);
    const r = e[4] !== void 0 ? +P(e[4], 0, 1) : 1;
    return n[3] = r, n;
  }
  if (e = t.match(Ge)) {
    const n = e.slice(1, 5);
    for (let r = 0; r < 4; r++)
      n[r] = +P(n[r], 0, 255);
    return n;
  }
  if ((e = t.match(Ye)) || (e = t.match(De))) {
    const n = e.slice(1, 4);
    n[0] = +G(n[0].replace("deg", ""), 0), n[1] = +P(G(n[1], 0), 0, 100) * 0.01, n[2] = +P(G(n[2], 0), 0, 100) * 0.01;
    const r = ct(Tt(n)), o = e[4] !== void 0 ? +P(e[4], 0, 1) : 1;
    return r[3] = o, r;
  }
  if (e = t.match(Xe)) {
    const n = e.slice(1, 4);
    n[1] *= 0.01, n[2] *= 0.01;
    const r = Tt(n);
    for (let o = 0; o < 3; o++)
      r[o] = We(r[o]);
    return r[3] = +e[4], r;
  }
  if (e = t.match(Te)) {
    const n = e.slice(1, 4);
    n[0] = P(G(n[0], 0), 0, 100), n[1] = P(G(n[1], 0), -125, 125, !0), n[2] = P(G(n[2], 0), -125, 125, !0);
    const r = gt();
    W("d50");
    const o = ct(Kt(n));
    W(r);
    const s = e[4] !== void 0 ? +P(e[4], 0, 1) : 1;
    return o[3] = s, o;
  }
  if (e = t.match(qe)) {
    const n = e.slice(1, 4);
    n[0] = P(n[0], 0, 100), n[1] = P(G(n[1], 0), 0, 150, !1), n[2] = +G(n[2].replace("deg", ""), 0);
    const r = gt();
    W("d50");
    const o = ct(Ut(n));
    W(r);
    const s = e[4] !== void 0 ? +P(e[4], 0, 1) : 1;
    return o[3] = s, o;
  }
  if (e = t.match(He)) {
    const n = e.slice(1, 4);
    n[0] = P(G(n[0], 0), 0, 1), n[1] = P(G(n[1], 0), -0.4, 0.4, !0), n[2] = P(G(n[2], 0), -0.4, 0.4, !0);
    const r = ct(Jt(n)), o = e[4] !== void 0 ? +P(e[4], 0, 1) : 1;
    return r[3] = o, r;
  }
  if (e = t.match(Ze)) {
    const n = e.slice(1, 4);
    n[0] = P(G(n[0], 0), 0, 1), n[1] = P(G(n[1], 0), 0, 0.4, !1), n[2] = +G(n[2].replace("deg", ""), 0);
    const r = ct(Oe(n)), o = e[4] !== void 0 ? +P(e[4], 0, 1) : 1;
    return r[3] = o, r;
  }
};
ee.test = (t) => (
  // modern
  Be.test(t) || Ye.test(t) || Te.test(t) || qe.test(t) || He.test(t) || Ze.test(t) || // legacy
  ze.test(t) || Ge.test(t) || De.test(t) || Xe.test(t) || t === "transparent"
);
l.prototype.css = function(t) {
  return n0(this._rgb, t);
};
const r0 = (...t) => new l(...t, "css");
$.css = r0;
_.format.css = ee;
_.autodetect.push({
  p: 5,
  test: (t, ...e) => {
    if (!e.length && C(t) === "string" && ee.test(t))
      return "css";
  }
});
_.format.gl = (...t) => {
  const e = x(t, "rgba");
  return e[0] *= 255, e[1] *= 255, e[2] *= 255, e;
};
const o0 = (...t) => new l(...t, "gl");
$.gl = o0;
l.prototype.gl = function() {
  const t = this._rgb;
  return [t[0] / 255, t[1] / 255, t[2] / 255, t[3]];
};
l.prototype.hex = function(t) {
  return $e(this._rgb, t);
};
const s0 = (...t) => new l(...t, "hex");
$.hex = s0;
_.format.hex = Me;
_.autodetect.push({
  p: 4,
  test: (t, ...e) => {
    if (!e.length && C(t) === "string" && [3, 4, 5, 6, 7, 8, 9].indexOf(t.length) >= 0)
      return "hex";
  }
});
const { log: Mt } = Math, Ke = (t) => {
  const e = t / 100;
  let n, r, o;
  return e < 66 ? (n = 255, r = e < 6 ? 0 : -155.25485562709179 - 0.44596950469579133 * (r = e - 2) + 104.49216199393888 * Mt(r), o = e < 20 ? 0 : -254.76935184120902 + 0.8274096064007395 * (o = e - 10) + 115.67994401066147 * Mt(o)) : (n = 351.97690566805693 + 0.114206453784165 * (n = e - 55) - 40.25366309332127 * Mt(n), r = 325.4494125711974 + 0.07943456536662342 * (r = e - 50) - 28.0852963507957 * Mt(r), o = 255), [n, r, o, 1];
}, { round: c0 } = Math, a0 = (...t) => {
  const e = x(t, "rgb"), n = e[0], r = e[2];
  let o = 1e3, s = 4e4;
  const c = 0.4;
  let a;
  for (; s - o > c; ) {
    a = (s + o) * 0.5;
    const f = Ke(a);
    f[2] / f[0] >= r / n ? s = a : o = a;
  }
  return c0(a);
};
l.prototype.temp = l.prototype.kelvin = l.prototype.temperature = function() {
  return a0(this._rgb);
};
const Dt = (...t) => new l(...t, "temp");
Object.assign($, { temp: Dt, kelvin: Dt, temperature: Dt });
_.format.temp = _.format.kelvin = _.format.temperature = Ke;
l.prototype.oklch = function() {
  return Ie(this._rgb);
};
const f0 = (...t) => new l(...t, "oklch");
Object.assign($, { oklch: f0 });
_.format.oklch = Oe;
_.autodetect.push({
  p: 2,
  test: (...t) => {
    if (t = x(t, "oklch"), C(t) === "array" && t.length === 3)
      return "oklch";
  }
});
Object.assign($, {
  analyze: Se,
  average: ir,
  bezier: gr,
  blend: T,
  brewer: Wr,
  Color: l,
  colors: at,
  contrast: Or,
  contrastAPCA: Gr,
  cubehelix: Lr,
  deltaE: Tr,
  distance: qr,
  input: _,
  interpolate: ft,
  limits: Pe,
  mix: ft,
  random: Sr,
  scale: Et,
  scales: Zr,
  valid: Hr
});
const Ht = [0.96, 0.907, 0.805, 0.697, 0.605, 0.547, 0.518, 0.445, 0.395, 0.34], we = [0.32, 0.16, 0.08, 0.04, 0, 0, 0.04, 0.08, 0.16, 0.32];
function i0(t) {
  const e = t.get("hsl.l");
  return Ht.reduce(
    (n, r) => Math.abs(r - e) < Math.abs(n - e) ? r : n
  );
}
function l0(t) {
  const e = $(t), n = i0(e), r = Ht.findIndex((s) => s === n), o = Ht.map((s) => e.set("hsl.l", s)).map((s) => $(s)).map((s, c) => {
    const a = we[c] - we[r];
    return a >= 0 ? s.saturate(a) : s.desaturate(a * -1);
  });
  return o[r] = $(t), { baseColorIndex: r, colors: o };
}
function u0(t) {
  return l0(t).colors.map((e) => e.hex());
}
const h0 = ({ color: t }) => u0(t), b0 = (t) => t === 0, d0 = (t, e) => e === !1 ? t[0] >= 255 && t[1] >= 255 && t[2] >= 255 : t[0] >= e && t[1] >= e && t[2] >= e, g0 = (t, e) => t[0] <= e && t[1] <= e && t[2] <= e;
function m0({
  imageData: t,
  quality: e,
  whiteThreshold: n = 235,
  // 250 is the default threshold for white pixels
  allowWhitePixels: r = !1
}) {
  const o = t.data, s = o.length / 4, c = [];
  let a = 0;
  for (let f = 0; f < s; f = f + e) {
    const i = f * 4, h = o[i + 0] || 0, d = o[i + 1] || 0, b = o[i + 2] || 0, g = o[i + 3] || 0, k = b0(g), R = d0([h, d, b], n);
    if (k)
      a++;
    else {
      if (g0([h, d, b], 35) || R && r === !1)
        continue;
      c.push([h, d, b]);
    }
  }
  return {
    /** Array of pixels processed from the image */
    pixels: c,
    /** Count of alpha pixels processed from the image */
    alphas: a
  };
}
const p0 = (t, e) => {
  const n = et(t), r = et(t).toHsl();
  return r.l > e ? et({ ...r, l: e }) : n;
}, w0 = "https://api.givebacks.dev/services/offer/proxy?url=", y0 = (t, e) => {
  const n = (e || w0) + t, r = new Image();
  return new Promise((o, s) => {
    r.crossOrigin = "", r.src = n, r.onload = () => {
      o(r);
    }, r.onerror = s;
  });
};
var Q, tt, F, Fe, Zt, Ue;
class k0 {
  constructor({ accuracy: e } = { accuracy: 5 }) {
    wt(this, F);
    wt(this, Q);
    wt(this, tt);
    z(this, "accuracy", 1);
    /** The extracted pixel data of the image */
    z(this, "imagePixelData", []);
    /** Color Data of the image in hex format */
    z(this, "primaryColor", "#EEEEEE");
    /** Dark color derived from the palette */
    z(this, "darkColor", "#22375A");
    /** The palette of the image, length on the colorCount parameter of the calculatePalette method */
    z(this, "palette", []);
    /** The shades of the palette */
    z(this, "colorShades", []);
    /**
     * React Bindings
     * */
    z(this, "listeners");
    /** Snapshot of the image processor used to sync external stores */
    z(this, "snapshot");
    this.accuracy = e || 1, this.listeners = /* @__PURE__ */ new Set(), this.snapshot = {
      colorShades: [],
      palette: [],
      primaryColor: this.primaryColor,
      darkColor: this.darkColor
    };
  }
  /**
   * Load an image from a source or bitmap to internal canvas
   * utilizing a proxy to load the image from a different domain if needed
   */
  async loadImage({ imageSrc: e, proxy: n, imageBitmap: r, image: o }) {
    if (e) {
      const s = await y0(e, n);
      yt(this, Q, new $t({ image: s }));
    } else (r || o) && yt(this, Q, new $t({ image: r || o }));
  }
  /**
   * Process the givin source with the provided accuracy
   * optionally load an image from a source or bitmap if not already loaded
   */
  processImage(e = {}) {
    if ((!rt(this, tt) || e.imageSrc || e.imageBitmap || e.image) && (this.loadImage(e), dt(this, F, Fe).call(this)), !rt(this, tt))
      throw new Error("Image data not loaded");
    const { pixels: n } = m0({
      imageData: rt(this, tt),
      quality: this.accuracy,
      allowWhitePixels: !1
    });
    return this.imagePixelData = n, this;
  }
  /**
   *  calculators
   *
   *  | ________ |
   *  ||12345678||
   *  |""""""""""|
   *  |[M|#|C][-]|
   *  |[7|8|9][+]|
   *  |[4|5|6][x]|
   *  |[1|2|3][%]|
   *  |[.|O|:][=]|
   *  |"--------"|
   */
  /**
   * Calculate the overall palette of the image based on the number of colors to return.
   * Utilizes quantize function which clusters values using median cut algorithm
   *
   * @param colorCount - How many colors should be in the palette
   * @returns The palette of the image
   */
  calculatePalette({ colorCount: e = 10 } = { colorCount: 10 }) {
    this.imagePixelData || this.processImage();
    const n = this.imagePixelData, r = nn(n, e), o = r ? r.palette() : [];
    return this.palette = o, dt(this, F, Zt).call(this, { ...this.snapshot, palette: o }), this;
  }
  /** Generates a color palette from the most common color in the image */
  generateColorShades({
    colorCount: e = 2
  } = { colorCount: 2 }) {
    var s;
    if (this.calculatePalette({ colorCount: e }), !this.palette)
      return [];
    const n = ((s = this.palette) == null ? void 0 : s[0]) || [255, 255, 255], r = et({
      r: n[0],
      g: n[1],
      b: n[2],
      a: 1
    }), o = h0({ color: r.toRgbString() });
    return this.colorShades = o.map((c) => et(c).toRgbString()), this.primaryColor = r.toHexString(), this.darkColor = p0(o[9], 0.2).toHexString(), dt(this, F, Zt).call(this, {
      ...this.snapshot,
      colorShades: this.colorShades,
      primaryColor: this.primaryColor,
      darkColor: this.darkColor
    }), o;
  }
  subscribe(e) {
    return this.listeners.add(e), () => this.listeners.delete(e);
  }
  getSnapshot() {
    return this.snapshot;
  }
  // Additional methods to consider:
  // calculateMean() {}
  // calculateMedian() {}
  // calculateMode() {}
  // getImageBorderData
  // calculateBackgroundGradient
  // findUseableColors -> this should return an accessible pallet of colors that can be used for the image
}
Q = new WeakMap(), tt = new WeakMap(), F = new WeakSet(), /**
 * Get the image data from the image canvas
 */
Fe = function() {
  var e;
  rt(this, Q) && yt(this, tt, (e = rt(this, Q)) == null ? void 0 : e.getImageData());
}, /** React Bindings */
/**
 * Set the snapshot of the image processor and notify listeners
 */
Zt = function(e) {
  this.snapshot = e, dt(this, F, Ue).call(this);
}, Ue = function() {
  this.listeners.forEach((e) => e());
};
const L0 = (t = {}) => {
  const [e] = rn(() => new k0(t));
  return on(
    (n) => e.subscribe(n),
    () => e.getSnapshot()
  ), e;
}, R0 = (t) => {
  const e = et(t);
  return {
    hex: e.toHexString(),
    rgb: e.toRgbString(),
    hsl: e.toHslString(),
    hsv: e.toHsvString(),
    luminance: e.getLuminance(),
    toAlpha: e.getAlpha()
  };
}, v0 = (t) => {
  const e = et({ r: t[0], g: t[1], b: t[2] });
  return {
    hex: e.toHexString(),
    rgb: e.toRgbString(),
    hsl: e.toHslString()
  };
};
export {
  $t as Canvas,
  k0 as ColorBot,
  E0 as ImageCanvas,
  A0 as LogoCanvas,
  R0 as colorTo,
  v0 as rgbPixelTo,
  L0 as useColorBot
};
